
export default function Services() {
  return (
    <section id="services" className="py-16 px-4 bg-white">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-4">
          サービス内容・料金
        </h2>
        <p className="text-center text-gray-600 font-normal text-sm md:text-base leading-relaxed mb-10 md:mb-12">
          ※呉市エリアは別途出張費をいただいております。<br />
          （詳細は下記をご確認ください）
        </p>

        <div className="space-y-6">
          {/* お掃除機能なし */}
          <div className="bg-gradient-to-br from-cyan-50 to-white rounded-2xl p-6 md:p-8 shadow-lg border-2 border-cyan-200">
            <div className="flex flex-col gap-3">
              <div className="text-left">
                <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-1">
                  家庭用エアコンクリーニング
                </h3>
                <p className="text-sm md:text-base text-gray-700 font-normal leading-relaxed">（お掃除機能なし）</p>
              </div>
              <div className="mt-2 text-left">
                <div className="text-4xl md:text-5xl font-bold text-cyan-600 leading-tight">
                  8,800<span className="text-lg md:text-xl font-bold text-gray-500 ml-1">円（税込）</span>
                </div>
                <p className="text-sm text-gray-500 font-normal mt-2 leading-relaxed">2台目以降 1台 7,700円</p>
              </div>
            </div>
          </div>

          {/* お掃除機能あり */}
          <div className="bg-gradient-to-br from-yellow-50 to-white rounded-2xl p-6 md:p-8 shadow-lg border-2 border-yellow-300">
            <div className="flex flex-col gap-3">
              <div className="text-left">
                <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-1">
                  家庭用エアコンクリーニング
                </h3>
                <p className="text-sm md:text-base text-gray-700 font-normal leading-relaxed">（お掃除機能あり）</p>
              </div>
              <div className="mt-2 text-left">
                <div className="text-4xl md:text-5xl font-bold text-yellow-600 leading-tight">
                  14,300<span className="text-lg md:text-xl font-bold text-gray-500 ml-1">円（税込）</span>
                </div>
                <p className="text-sm text-gray-500 font-normal mt-2 leading-relaxed">2台目以降 1台 13,200円</p>
              </div>
            </div>
          </div>
        </div>

        {/* 注意事項 */}
        <div className="mt-10 bg-gray-50 rounded-xl p-5 md:p-6">
          <div className="flex items-start gap-3">
            <i className="ri-information-line text-2xl text-cyan-600 flex-shrink-0 mt-0.5"></i>
            <div className="text-sm text-gray-700 font-normal space-y-2 text-left leading-relaxed">
              <p>※ 家電量販店で月100台のクリーニング実績があります</p>
              <p>※ エアコンクリーニングの事ならお任せください</p>
              <p>※ 高齢者施設・飲食店・個人店舗・空き家のエアコンクリーニングをお考えの方もご相談ください</p>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="mt-10 text-center">
          <p className="text-gray-700 font-normal text-sm md:text-base leading-relaxed mb-5">料金やサービス内容についてのご質問はお気軽にどうぞ</p>
          <a
            href="https://lin.ee/ltlhjZa"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-white border-2 border-[#06C755] text-[#06C755] hover:bg-[#06C755]/10 font-bold py-3.5 px-8 rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-line-fill text-lg"></i>
            <span>LINEで質問する</span>
          </a>
        </div>
      </div>
    </section>
  );
}
